import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

const N = 5;
const TOTAL = N * N;

export function SchulteTable({ onScore }) {
  const [order, setOrder] = useState([]);
  const [next, setNext] = useState(1);
  const [running, setRunning] = useState(false);
  const [done, setDone] = useState(false);
  const [time, setTime] = useState(0);
  const [wrong, setWrong] = useState(-1);
  const reported = useRef(false);

  useEffect(() => { if (!running) return; const id = setInterval(() => setTime((t) => t + 0.1), 100); return () => clearInterval(id); }, [running]);

  const start = () => {
    const nums = [...Array(TOTAL).keys()].map((i) => i + 1).sort(() => Math.random() - 0.5);
    setOrder(nums); setNext(1); setTime(0); setRunning(true); setDone(false); reported.current = false;
  };

  const tap = (num) => {
    if (!running) return;
    if (num === next) {
      if (num === TOTAL) { setRunning(false); setDone(true); }
      setNext(num + 1);
    } else {
      setWrong(num); setTimeout(() => setWrong(-1), 200);
    }
  };

  useEffect(() => { if (done && !reported.current) { reported.current = true; onScore?.(Math.max(100, 3000 - Math.round(time * 50))); } }, [done, time, onScore]);

  return (
    <div className="flex flex-col items-center" data-testid="schulte-table">
      <div className="flex items-center gap-5 mb-4 font-mono">
        <span className="text-neon-cyan text-lg" data-testid="schulte-next">FIND: {Math.min(next, TOTAL)}</span>
        <span className="text-neon-yellow text-lg">⏱ {time.toFixed(1)}s</span>
      </div>
      <div className="relative grid gap-1.5 p-1.5 bg-zinc-900 border-2 border-zinc-700 rounded-xl" style={{ gridTemplateColumns: `repeat(${N}, 1fr)`, width: "min(92vw, 360px)" }}>
        {order.map((num) => (
          <button key={num} onClick={() => tap(num)} data-testid={`schulte-${num}`}
            className="aspect-square rounded-lg font-display font-black text-xl flex items-center justify-center transition-colors"
            style={{
              background: wrong === num ? "#FF003C" : num < next ? "#18181b" : "#27272a",
              color: num < next ? "#39FF14" : "#fff",
            }}>
            {num}
          </button>
        ))}
        {!running && (
          <div className="absolute inset-0 bg-black/85 rounded-xl flex flex-col items-center justify-center gap-3">
            {done && <p className="font-display font-black text-2xl text-neon-lime uppercase" data-testid="schulte-done">Done in {time.toFixed(1)}s!</p>}
            <Button onClick={start} data-testid="schulte-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase">
              <Play className="w-4 h-4 mr-1 fill-black" /> {done ? "Play Again" : "Start"}
            </Button>
          </div>
        )}
      </div>
      <p className="text-zinc-500 text-xs font-mono mt-3">Tap numbers 1 → 25 in order as fast as you can!</p>
    </div>
  );
}
